import script from "./SliderPart.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderPart.vue?vue&type=script&setup=true&lang=js"

import "./SliderPart.vue?vue&type=style&index=0&id=a3e58040&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3e58040"]])

export default __exports__